import { HttpClient } from '@angular/common/http';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UiServiceEnvironment, UiServicesBrochure, UiServicesLogger, UiServicesMessage, UiServicesPayments, UiServicesSchedule, UiServicesUtils, UiServiceWebSession } from '@drct-web-apps/ui-services';
import { DRCTWebConfig } from '@drct-web-apps/ui-types';
import { UiWebFooterComponent } from '@drct-web-apps/ui-web-footer';
import { UiWebHeaderComponent } from '@drct-web-apps/ui-web-header';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
    selector: 'ui-web-home',
    imports: [
        RouterOutlet,
        UiWebHeaderComponent,
        UiWebFooterComponent
    ],
    templateUrl: './ui-web-home.component.html'
})
export class UiWebHomeComponent implements OnInit, OnDestroy {
    private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    private readonly http        = inject(HttpClient);
    private readonly utils       = inject(UiServicesUtils);
    private readonly webSession  = inject(UiServiceWebSession);
    private readonly payments    = inject(UiServicesPayments);
    private readonly msgBus      = inject(UiServicesMessage);
    private readonly router      = inject(Router);
    private readonly logger      = inject(UiServicesLogger);
    private readonly brochure    = inject(UiServicesBrochure);
    private readonly env         = inject(UiServiceEnvironment);
    private readonly webSchedule = inject(UiServicesSchedule);

    constructor() {
      this.logger.AppName = 'WEB';
    }

    ngOnInit(): void {
      this.utils.showHidePageLoader(true);
      document.querySelector('body')?.setAttribute("drct-web-version", this.env.version ?? '');

      this.payments.paymentLibReady
                   .pipe(takeUntil(this.destroyed$))
                   .subscribe((ready: boolean) => {
                      if(ready) {
                        this.msgBus.initBroadcastChannel();
                        this.payments.startMessageListening();
                        this.loadWebConfig();
                      }
                   });

      this.router.events
                 .pipe(takeUntil(this.destroyed$))
                 .subscribe((event) => {
                    if(event instanceof NavigationEnd) {
                      this.logger.log(`User Navigated to: ${event.url}`);
                    }
                 });

      this.webSession.sessionReady
                     .pipe(takeUntil(this.destroyed$))
                     .subscribe((ready: boolean) => {
                        if(ready) {
                          this.utils.showHidePageLoader(false);
                          this.logger.log('Web Session is Ready');
                        }
                      });
    }
    
    ngOnDestroy() {
      this.msgBus.closeBroadcastChannel();
      this.brochure.resetObject();
      this.payments.OnDestroy();
      this.logger.onDestroy();
      this.destroyed$.next(true);
      this.destroyed$.complete();
    }


    
    private loadWebConfig(): void {
      const data: DRCTWebConfig = {
        opr: "load-web",
        uuid: this.webSession.webConfig?.uuid ?? '',
      }
  
      this.logger.log('Loading Web Config...');
      this.http.post(this.utils.builApiUrlWithEnv("drct_config.php"), data)
               .pipe(takeUntil(this.destroyed$))
               .subscribe({
                  next:(response: DRCTWebConfig) => {
                    if(response.success && response.tot_rows &&  response.tot_rows > 0) {
                      this.webSession.webConfig = response;
                      this.payments.initPayments(response.environment ?? '');
                      this.brochure.setBrochureNames(response.brochure_pdfs ?? '');
                      this.logger.log('Web Config Loaded: ' + JSON.stringify(response));
                    }
                  },
                  error: (error) => { }
                });
    }
}
